import styles from './Pagination.module.css'; // or pass classNames as props
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  theme?: 'light' | 'dark';
  getPaginationRange: () => (number | string)[];
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,

  getPaginationRange,
}) => {
  const hasPreviousPage = currentPage > 1;
  const hasNextPage = currentPage < totalPages;

  return (
    <div className={styles.pagination}>
      <button onClick={() => onPageChange(currentPage - 1)} disabled={!hasPreviousPage}>
        <ArrowLeftIcon className={`${styles.arrow} ${!hasPreviousPage ? styles.disabled : ''}`} />
      </button>

      {getPaginationRange().map((page, index) =>
        typeof page === 'number' ? (
          <button
            key={index}
            onClick={() => onPageChange(page)}
            className={currentPage === page ? styles.currentPage : ''}
          >
            {page}
          </button>
        ) : (
          <span key={index} className={styles.ellipsis}>
            {page}
          </span>
        )
      )}

      <button onClick={() => onPageChange(currentPage + 1)} disabled={!hasNextPage}>
        <ArrowRightIcon className={`${styles.arrow} ${!hasNextPage ? styles.disabled : ''}`} />
      </button>
    </div>
  );
};

export default Pagination;
